import apiClient from './client';
import type { PaginatedResponse } from '@/types/api';

export interface Account {
  id: number;
  company_id: number;
  name: string;
  utage_url: string;
  target_card_headers?: string[] | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface AccountListParams {
  page?: number;
  per_page?: number;
  company_id?: number;
  is_active?: boolean;
}

export interface AccountCreateInput {
  company_id: number;
  name: string;
  utage_url: string;
  target_card_headers?: string[] | null;
  is_active?: boolean;
}

export interface AccountUpdateInput {
  name?: string;
  utage_url?: string;
  target_card_headers?: string[] | null;
  is_active?: boolean;
}

export const accountsApi = {
  // アカウント一覧取得
  getAccounts: async (params?: AccountListParams): Promise<PaginatedResponse<Account>> => {
    const response = await apiClient.get<PaginatedResponse<Account>>('/api/accounts', { params });
    return response.data;
  },

  // アカウント詳細取得
  getAccount: async (id: number): Promise<Account> => {
    const response = await apiClient.get<Account>(`/api/accounts/${id}`);
    return response.data;
  },

  // アカウント作成
  createAccount: async (data: AccountCreateInput): Promise<Account> => {
    const response = await apiClient.post<Account>('/api/accounts', data);
    return response.data;
  },

  // アカウント更新
  updateAccount: async (id: number, data: AccountUpdateInput): Promise<Account> => {
    const response = await apiClient.patch<Account>(`/api/accounts/${id}`, data);
    return response.data;
  },

  // アカウント削除
  deleteAccount: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/accounts/${id}`);
  },
};
